import styled from '@emotion/styled'
import { Button } from '@mui/material'
import { CallToAction } from './types'

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;

  button {
    margin: 0 8px;
    text-transform: capitalize;
    pointer-events: all;
  }
`

interface Props {
  callToActionBtns: CallToAction[]
}

export const Actions = ({ callToActionBtns }: Props) => {
  return (
    <Container>
      {callToActionBtns.map(({ btnText, onClick, variant }) => (
        <Button
          key={btnText}
          color="primary"
          variant={variant || 'outlined'}
          onClick={onClick}
          disableElevation={true}
        >
          {btnText}
        </Button>
      ))}
    </Container>
  )
}
